import domReady from '@wordpress/dom-ready';
import anime from 'animejs';
import 'intersection-observer';

domReady(function() {
  // element for the browser to watch
  const tickerEl = document.querySelectorAll('.ticker-animate');

  // intersectionObserver config options, this is optional
  const config = {
    threshold: 1, // 100% of the object to be in the viewport
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.intersectionRatio > 0) {
        initTicker(entry.target);

        observer.unobserve(entry.target); // stop observing element once its in viewport and runs animation function
      }
    });
  }, config);

  tickerEl.forEach((ticker) => {
    observer.observe(ticker);
  });
});

/**
 * Function setting up ticker animations
 *
 * @param {string} el - DOMString to match
 */
function initTicker(el) {
  const endValue = el.getAttribute('data-end-value');
  const incrementValue = el.getAttribute('data-increment');
  const durationValue = el.getAttribute('data-duration');

  if (endValue) {
    numberAnimation(el, endValue, incrementValue, durationValue);
  }
}

/**
 * Helper method for creating ticker animations
 *
 * @param {string} el - DOMString to match
 * @param {string} endValue - string to ticker to
 * @param {number} incrementor - Optional, defaults to 2
 * @param {number} duration - number for how long the animation runs
 */
function numberAnimation(el, endValue, incrementor, duration) {
  anime({
    targets: el,
    textContent: endValue,
    round: incrementor ? 1 / incrementor : 1 / 5,
    easing: 'easeInOutQuad',
    duration: duration ? duration : 4000,
  });
}
